<template>
    <el-dialog
    :title="isModify? '重置密码提示':'用户注册须知'"
    :visible.sync="dialogVisible"
    width="500px"
    class="user-tips"
    center
  >
      <div class="content">
        <div class="c-title">
        尊敬的用户，您好！
        </div>
        <div class="c-body">
          感谢您对CEATI联盟的关注。<br><br>
          <template v-if="isModify">
          您的修改密码申请成功提交后，我们将会给您的注册邮箱 <span class="link-color">{{email}}</span> 发送一份确认邮件。请查阅邮件，并在24小时内点击其中的链接激活您的账号。
          </template>
          <template v-else>
          注册申请成功提交后，我们将会给您的注册邮箱 <span class="link-color">{{email}}</span> 发送一份激活邮件。请查阅邮件，并在24小时内点击其中的链接激活您的账号。邮件激活验证成功后，我们将会对您的注册信息进行审核，审核完成后会发送邮件到您的邮箱。请注意查收您的邮件。
          </template>
          <br><br>

          若收不到邮件，请检查你的垃圾箱或广告箱，邮件有可能被误认为垃圾或广告邮件。您也可以重新提交申请，或者联系我们 ti_support@qianxin.com。
        </div>

        <div class="c-foot">
          奇安信威胁情报中心
        </div>
      </div>
    </el-dialog>
</template>

<script>
export default {
  props: {
    isModify: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showDialog () {
      this.dialogVisible = true;
      // this.getCode();
    }
  }
}
</script>

<style lang="scss" scoped>
.user-tips{
  ::v-deep .el-dialog{
     margin-top: 25vh;
    .el-dialog__header{
      text-align: left;
      background: #141D31;
      padding: 5px;
      .el-dialog__title{
        color: #fff;
        font-size: 14px
      }
      .el-dialog__headerbtn .el-dialog__close{
        color: #fff;
      }
      .el-dialog__headerbtn{
        top: 10px;
      }
    }
    .el-dialog__body{
      background: #E5E7F0;
    }
  }
  .content{
    .c-title{
      font-size: 14px;
      font-weight: bold;
      color: #1C1C1D;
      margin-bottom: 20px;
    }
    .c-body{
      color: #2A2B2D;
      line-height: 20px;
      font-size: 13px;
      .link-color{
        color: #274FEB;
      }
    }
    .c-foot{
      text-align: right;
      color: #303032;
      margin-top: 40px;
      font-weight: bold;
    }

  }
}
</style>
